/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CredentialIssuanceConfigRequest,
  CredentialIssuanceExecutionRequest,
  CredentialIssuanceStartRequest,
  CredentialIssuanceStateResponse,
  IssuerNamesResponse,
  ResponseDto,
} from '../models/index';
import {
    CredentialIssuanceConfigRequestFromJSON,
    CredentialIssuanceConfigRequestToJSON,
    CredentialIssuanceExecutionRequestFromJSON,
    CredentialIssuanceExecutionRequestToJSON,
    CredentialIssuanceStartRequestFromJSON,
    CredentialIssuanceStartRequestToJSON,
    CredentialIssuanceStateResponseFromJSON,
    CredentialIssuanceStateResponseToJSON,
    IssuerNamesResponseFromJSON,
    IssuerNamesResponseToJSON,
    ResponseDtoFromJSON,
    ResponseDtoToJSON,
} from '../models/index';

export interface ConfigureRequest {
    credentialIssuanceConfigRequest: CredentialIssuanceConfigRequest;
}

export interface LaunchRequest {
    credentialIssuanceExecutionRequest: CredentialIssuanceExecutionRequest;
}

export interface StartOrFind1Request {
    credentialIssuanceStartRequest: CredentialIssuanceStartRequest;
}

export interface Status1Request {
    workflow?: string;
}

/**
 * 
 */
export class CredIssueControllerApi extends runtime.BaseAPI {

    /**
     * Cancel Cred Issue workflow instance, called by user
     * @deprecated
     */
    async cancellationInstanceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/cred-issue/cancellation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Cancel Cred Issue workflow instance, called by user
     * @deprecated
     */
    async cancellationInstance(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.cancellationInstanceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Async operation. Result can be found in the status endpoint
     * Configure existed Credentials Issuance Workflow
     * @deprecated
     */
    async configureRaw(requestParameters: ConfigureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['credentialIssuanceConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'credentialIssuanceConfigRequest',
                'Required parameter "credentialIssuanceConfigRequest" was null or undefined when calling configure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/cred-issue/configuration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialIssuanceConfigRequestToJSON(requestParameters['credentialIssuanceConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Async operation. Result can be found in the status endpoint
     * Configure existed Credentials Issuance Workflow
     * @deprecated
     */
    async configure(requestParameters: ConfigureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.configureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of configured issuer names. Can be used to set IssueeAutomation and IssuerAutomation.
     * Get possible issuer names
     * @deprecated
     */
    async getIssuerNames1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssuerNamesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/cred-issue/issuer-names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssuerNamesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of configured issuer names. Can be used to set IssueeAutomation and IssuerAutomation.
     * Get possible issuer names
     * @deprecated
     */
    async getIssuerNames1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssuerNamesResponse> {
        const response = await this.getIssuerNames1Raw(initOverrides);
        return await response.value();
    }

    /**
     * Async operation. Result can be found in the status endpoint
     * Starts the automatic issuance process with oobi resolving, issuing, admitting and the rest operations
     * @deprecated
     */
    async launchRaw(requestParameters: LaunchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['credentialIssuanceExecutionRequest'] == null) {
            throw new runtime.RequiredError(
                'credentialIssuanceExecutionRequest',
                'Required parameter "credentialIssuanceExecutionRequest" was null or undefined when calling launch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/cred-issue/launch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialIssuanceExecutionRequestToJSON(requestParameters['credentialIssuanceExecutionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Async operation. Result can be found in the status endpoint
     * Starts the automatic issuance process with oobi resolving, issuing, admitting and the rest operations
     * @deprecated
     */
    async launch(requestParameters: LaunchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.launchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all recipient workflow ids of Cred identity types.
     * Return recipient cred identity workflow ids
     * @deprecated
     */
    async recipientWorkflows1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CredentialIssuanceStateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/cred-issue/recipient-identity-workflow`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CredentialIssuanceStateResponseFromJSON(jsonValue));
    }

    /**
     * Returns all recipient workflow ids of Cred identity types.
     * Return recipient cred identity workflow ids
     * @deprecated
     */
    async recipientWorkflows1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CredentialIssuanceStateResponse | null | undefined > {
        const response = await this.recipientWorkflows1Raw(initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * The only way to create the workflow
     * Start Credentials Issuance Workflow or find if already exists
     * @deprecated
     */
    async startOrFind1Raw(requestParameters: StartOrFind1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['credentialIssuanceStartRequest'] == null) {
            throw new runtime.RequiredError(
                'credentialIssuanceStartRequest',
                'Required parameter "credentialIssuanceStartRequest" was null or undefined when calling startOrFind1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/cred-issue/start-or-find`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialIssuanceStartRequestToJSON(requestParameters['credentialIssuanceStartRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * The only way to create the workflow
     * Start Credentials Issuance Workflow or find if already exists
     * @deprecated
     */
    async startOrFind1(requestParameters: StartOrFind1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.startOrFind1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requests state machine and returns the status according to it. If workflow id is not set, finds one that was created by requester. If workflow is not found, returns 204
     * Return workflow status
     * @deprecated
     */
    async status1Raw(requestParameters: Status1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CredentialIssuanceStateResponse>> {
        const queryParameters: any = {};

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/cred-issue/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CredentialIssuanceStateResponseFromJSON(jsonValue));
    }

    /**
     * Requests state machine and returns the status according to it. If workflow id is not set, finds one that was created by requester. If workflow is not found, returns 204
     * Return workflow status
     * @deprecated
     */
    async status1(requestParameters: Status1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CredentialIssuanceStateResponse | null | undefined > {
        const response = await this.status1Raw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

}
